import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-43b4fd92"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "text-value" };
import { ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TextInput',
    props: {
        modelValue: {}
    },
    emits: ['update:modelValue'],
    setup(__props, { emit }) {
        const props = __props;
        const textValue = ref(props.modelValue);
        const emitUpdate = () => {
            emit('update:modelValue', textValue.value);
        };
        watch(() => props.modelValue, newVal => {
            textValue.value = newVal;
        }, { immediate: true, deep: true });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((textValue).value = $event)),
                    type: "text",
                    onInput: emitUpdate
                }, null, 544), [
                    [_vModelText, textValue.value]
                ])
            ]));
        };
    }
});
